module.exports = __webpack_public_path__ + "static/media/custom-keyboard-destination.baa96616.svg";